import { CreativeProjectTimelineItem } from "@repo/api/creative-project";
import { CompositionDto } from "@repo/api/editor";
import { AnimatedImageDto } from "@repo/api/animated-image";
import { getAnimatedImageConfig } from "@repo/api/utils/composition";

type Crop = {
  x: number;
  y: number;
  scale: number;
  overflow: "width" | "height";
};

export function parseCrop(
  timelineItem: CreativeProjectTimelineItem,
  animatedImage: AnimatedImageDto | undefined,
  aspectRatio: CompositionDto["aspectRatio"],
): Crop | null {
  if (!animatedImage || animatedImage.status !== "COMPLETED") {
    return null;
  }

  const config = getAnimatedImageConfig(timelineItem);

  const cropArea = config.cropConfigs[aspectRatio];
  const { width, height } = animatedImage;

  if (!cropArea || !width || !height) {
    return null;
  }

  const playerAspectRatioParts = aspectRatio
    .split(":")
    .map((val) => parseInt(val));

  const playerAspectRatio =
    playerAspectRatioParts[0]! / playerAspectRatioParts[1]!;

  const animatedImageAspectRatio = width / height;

  const overflow =
    animatedImageAspectRatio > playerAspectRatio ? "width" : "height";

  const scaleVar = overflow === "width" ? cropArea.height : cropArea.width;
  const scale = 1 / (scaleVar / 100);

  return {
    x: cropArea.x,
    y: cropArea.y,
    scale,
    overflow,
  };
}
